export type TelephonyIframeMessage = {
    notificationType: telephonyNotificationTypes
    message?: Record<string, string>
}

export enum telephonyNotificationTypes {
    data = "TELEPHONY-DATA",
    status = "TELEPHONY-STATUS",
    incoming = "TELEPHONY-INCOMMING-CALL",
    terminate = "TELEPHONY-TERMINATE-CALL",
    ready = "TELEPHONY-READY",
    initialData = "TELEPHONY-INITIAL-DATA"
}

export const telephonyDomEvent = "TelephonyDomEvent"

export type TelephonySocketMessage = {
    omni_user_id: string
    dialog_id: string
    customer_id: string
    customer_agent_id: string
    data: TelephonyIframeMessage
}
